// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__11_aw","title":"Info_title__36O_Q","links":"Info_links__31nfL","link":"Info_link__2HJ0s","logo":"Info_logo__3JoDM"};